import {i18n} from '@/plugins/i18n'

export const walletSettlementPeriodLimit = {
    STANDARD: 1,
    LESS_LIMIT: 2,
    NO_LIMIT: 3,

//     const  = 1; // no direct settlement between 11pm till 5am
// const  = 2; // no direct settlement between 11pm till 2am
// const  = 3; // no limit whole day
};

export const walletSettlementPeriodLimitStr = {
    STANDARD: i18n.t('wallets.settlement_period_limit.standard'),
    LESS_LIMIT: i18n.t('wallets.settlement_period_limit.less_limit'),
    NO_LIMIT: i18n.t('wallets.settlement_period_limit.no_limit'),

    get(type) {
        let limit_str = null;

        Object.keys(walletSettlementPeriodLimit).forEach(item => {
            if (walletSettlementPeriodLimit[item] === type) {
                limit_str = walletSettlementPeriodLimitStr[item];
            }
        });

        return limit_str;
    }
};
